<template>
  <div class="environment-grid">
    <div
      v-for="environment in environments"
      :key="environment.id"
      class="image-outer"
    >
      <div class="image-inner" @click="selectEnvironment(environment)">
        <div
          class="thumbnail-wrapper"
          :class="{ 'thumbnail-selected': environment.key === selectedEnvironment }"
          :aria-label="`${environment.name.en} Thumbnail`"
          :data-testid="`thumbnail-${environment.key}`"
        >
          <img
            :src="pictureFor(environment)"
            class="thumbnail-img"
            :alt="environment.name.en"
          >
        </div>
        <span>{{ environment.name.en }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';

export default {
  name: 'environment-grid',
  props: {
    environments: {
      type: Array,
      default: () => []
    },
    selectedEnvironment: {
      type: String,
      default: null,
    },
  },
  methods: {
    pictureFor(location) {
      return get(location, 'picture.url', 'http://icons.iconarchive.com/icons/papirus-team/papirus-status/512/image-missing-icon.png');
    },
    selectEnvironment(environment) {
      this.$emit('select', environment)
    }
  }
}
</script>

<style scoped>
.environment-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; /* automatically spaces between items, but no gap on the outer edge */
}

.image-outer {
  display: inline-block;
}

.image-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.thumbnail-wrapper {
  aspect-ratio: 1 / 1;
  width: 160px;
  height: 160px;
  overflow: hidden;
  margin-bottom: 8px;
}

.thumbnail-selected {
  outline: 4px solid #3f83c5;
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  box-sizing: border-box;
  cursor: pointer;
}
</style>